export enum SelectCasesType {
  Initial = 'initial',
  Target = 'target',
}

export type BaseSuggestedRouteProps = {
  taskId: string;
  chainNumber: number;
};
